import React from 'react';
import { MailIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 px-4 bg-white" data-id="element-39">
      <div className="max-w-6xl mx-auto" data-id="element-40">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16" data-id="element-41">
          Let's Work Together
        </h2>
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-42">
          <div className="w-full lg:w-1/2" data-id="element-43">
            <h3 className="text-2xl font-semibold text-gray-800 mb-6" data-id="element-44">
              Get In Touch
            </h3>
            <p className="text-lg text-gray-600 mb-8" data-id="element-45">
              Ready to elevate your content? I'm here to help you create
              engaging and effective content that drives results. Reach out
              directly or fill out the form.
            </p>
            <div className="space-y-6" data-id="element-46">
              <div className="flex items-start" data-id="element-47">
                <div className="mr-4 bg-blue-100 p-3 rounded-full" data-id="element-48">
                  <MailIcon className="h-6 w-6 text-blue-600" data-id="element-49" />
                </div>
                <div data-id="element-50">
                  <h4 className="font-semibold text-gray-800" data-id="element-51">Email</h4>
                  <a href="mailto:Adeyeyeafeez6@gmail.com" className="text-blue-600 hover:underline inline-flex items-center font-medium" data-id="element-52">
                    Adeyeyeafeez6@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start" data-id="element-53">
                <div className="mr-4 bg-blue-100 p-3 rounded-full" data-id="element-54">
                  <MessageCircleIcon className="h-6 w-6 text-blue-600" data-id="element-55" />
                </div>
                <div data-id="element-56">
                  <h4 className="font-semibold text-gray-800" data-id="element-57">Telegram</h4>
                  <a href="https://t.me/Repfix_Director" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-58">
                    @Repfix_Director
                  </a>
                </div>
              </div>
              <div className="flex items-start" data-id="element-59">
                <div className="mr-4 bg-blue-100 p-3 rounded-full" data-id="element-60">
                  <PhoneIcon className="h-6 w-6 text-blue-600" data-id="element-61" />
                </div>
                <div data-id="element-62">
                  <h4 className="font-semibold text-gray-800" data-id="element-63">WhatsApp</h4>
                  <a href="https://wa.me/2348134402660" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-64">
                    +2348134402660
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2" data-id="element-65">
            <form className="bg-blue-50 p-8 rounded-xl shadow-sm border border-blue-100" data-id="element-66">
              <div className="mb-6" data-id="element-67">
                <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-68">
                  Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" placeholder="Your name" data-id="element-69" />
              </div>
              <div className="mb-6" data-id="element-70">
                <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-71">
                  Email
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" placeholder="Your email address" data-id="element-72" />
              </div>
              <div className="mb-6" data-id="element-73">
                <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-74">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600" placeholder="How can I help you?" data-id="element-75"></textarea>
              </div>
              <button type="submit" className="w-full bg-blue-600 text-white py-4 px-6 rounded-lg font-medium hover:bg-blue-700 transition-colors" data-id="element-76">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}